// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__YiW1j","select":"select__2C0l-","scrollbar":"scrollbar__2ZyZL"};